import { token } from '$lib/features/auth/authStore';
import { createAIClient } from '@onelab/ai';

export const ai = createAIClient({
  endpoint: import.meta.env.VITE_AI_ENDPOINT,
});
token.subscribe((t) => {
  ai.setToken(t);
});

export function getReadableLabresults(testPhase) {
  return {
    labResults: testPhase.samples?.map(({ summary, name }) => {
      const { medium, neutral, normal, negative, index } = summary;
      return {
        name,
        employeesWithMediumValues: `${medium}%`,
        employeesWithNeutralValues: `${neutral}%`,
        employeesWithNormalValues: `${normal}%`,
        employeesWithNegativeValues: `${negative}%`,
        ...(index && {
          comparedToOtherCompanies: {
            employeesWithMediumValues: `${index.medium}%`,
            employeesWithNeutralValues: `${index.neutral}%`,
            employeesWithNormalValues: `${index.normal}%`,
            employeesWithNegativeValues: `${index.negative}%`,
          },
        }),
      };
    }),
  };
}

export function getReadableSurveyAnswers(testPhase) {
  // Since the AI model can't handle all survey questions, we pick the most important ones. "Base" questions - not follow-ups
  const QUESTION_IDS_TO_USE_FOR_AI = [
    47, 149, 153, 130, 140, 124, 119, 125, 164, 152, 167, 151, 168, 67, 68, 69,
    70, 71, 72, 73, 76,
  ];
  return {
    survey: testPhase.survey
      ?.filter((q) => QUESTION_IDS_TO_USE_FOR_AI.includes(q.id))
      .map((question) => ({
        question: question.title,
        answers: question.summary.options.map((option) => ({
          title: option.title,
          percentage: option.percent,
        })),
      })),
  };
}
